
import React, { useEffect, useState } from 'react';
import { apiRequest } from '@/utils/request';

import { Button, InputOTP, Label, Link } from '@/components/ui';

export function LoginOTP({ email, password, onAlert, backToLogin }) {
    const
        [autoTrigger, setAutoTrigger] = useState(true),
        [code, setCode] = useState(''),
        [formFilled, setFormFilled] = useState(false),
        [loadingSubmit, setLoadingSubmit] = useState(false),
        [loadingResend, setLoadingResend] = useState(false);

    useEffect(() => {
        const formFilled = code.length === 6;

        setFormFilled(formFilled);
    }, [code]);

    const onOtpChange = (value) => {
        setCode(value);

        if (autoTrigger && value.length === 6) {
            handleOtpSubmit(value);
            setAutoTrigger(false);
        }
    };

    const handleOtpSubmit = async (value) => {
        setLoadingSubmit(true);

        const otpCode = value || code;

        if (otpCode.length !== 6) {
            onAlert(i18next.t('otp.enter_6_digit_code'), 'warning', i18next.t('ui.attention'));
            return;
        }

        const data = {
            email,
            password,
            code: otpCode
        };

        try {
            const response = await apiRequest('/login', 'POST', data);

            if (response.status === 201) {
                WiseMetering.startApp();
            } else {
                onAlert(i18next.t('ui.login.failed'), 'destructive', i18next.t('alert_boxes.failed'));
            }
        } catch (err) {
            const errorMessage = err.response?.data?.error?.capitalize() || i18next.t('alert_boxes.error_occurred');

            onAlert(errorMessage, 'destructive', i18next.t('alert_boxes.failed'));
        } finally {
            setTimeout(() => {
                setLoadingSubmit(false);
            }, 500);
        }
    };

    const handleResendOtp = async () => {
        setLoadingResend(true);

        const data = {
            email,
            password
        };

        try {
            const response = await apiRequest('/login', 'POST', data);

            if (response.status === 200) {
                onAlert(i18next.t('otp.new_code_sent'), 'info', i18next.t('alert_boxes.info'));
            }
        } catch (err) {
            const errorMessage = err.response?.data?.error?.capitalize() || i18next.t('alert_boxes.error_occurred');

            onAlert(errorMessage, 'destructive', i18next.t('alert_boxes.failed'));
        } finally {
            setTimeout(() => {
                setLoadingResend(false);
            }, 500);
        }
    };

    return (
        <div className="tw-grid tw-gap-4">
            <div className="tw-flex tw-flex-col tw-items-center tw-gap-4">
                <Label htmlFor="otp">{i18next.t('otp.enter_code_sent_to_email')}</Label>
                <InputOTP length={6} value={code} onChange={onOtpChange}/>
            </div>
            <Button type="submit" loading={loadingSubmit} onClick={() => handleOtpSubmit()} fullWidth tone="secondary" disabled={!formFilled}>
                {i18next.t('otp.verify')}
            </Button>
            <div className="tw-flex tw-justify-between tw-gap-2">
                <Link icon="arrowLeftCircle" onClick={backToLogin} text={i18next.t('ui.passwords.back_to_login')} variant="body"/>
                <Link loading={loadingResend} onClick={handleResendOtp} text={i18next.t('otp.resend_code')} variant="body"/>
            </div>
        </div>
    );
}
